import React, {  Component } from 'react';
import _ from 'lodash';

export default class AvailabilityByADCOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog(false);
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
		const self = this;
		const { warehouseCode, responseObject } = self.props.data;
		let sum = 0;
		if(responseObject) {
			responseObject.forEach(itm => {
				if(itm.availableQty) {
					sum += parseInt(itm.availableQty, 10);
				}
			});
		}
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="availabilityByADCOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Availability by ADC</h2>
                    <table className="dataTable availabilityByADCTable">
                        <thead>
                            <tr>
                                <th className="uppercase adc">
                                    ADC
                                    {/* or "Cluster ADC" [don't output ALL CAPS in the HTML code.  Use "uppercase" CSS class as shown here.] */}
                                </th>
                                <th className="availability">
                                    Available
                                </th>
                            </tr>
                        </thead>
                        <tbody>
							{responseObject && responseObject.map((item, index) => {
                                // Filtering out warehouses ONT and DA2 till we add this filter in the backend, WCP-8129
                                if (['ONT', 'DA2'].includes(item.warehouseCode)) {
                                    return null;
                                }
								return <tr key={index} className={item.warehouseCode === warehouseCode ? "bold" : ""}>
	                                <td className="adc">{item.warehouseCode}{item.warehouseCode === warehouseCode && "*"}</td>
	                                <td className="availability">{item.availableQty}</td>
	                            </tr>
							})}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td className="adc">Total <span className="unbold">(All ADCs)</span></td>
                                <td className="availability">
									{ sum }
								</td>
                            </tr>
                        </tfoot>
                    </table>
                    <p className="disclaimer">* Customer Warehouse</p>
                 </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/availabilityByADCOverlayDialog.js